<script>
import inViewport from 'vue-in-viewport-mixin'

const config = {
  // In ms
  INTERVAL: 4000,

  // Tabs count
  COUNT: 4
}

export default {
  name: 'HomeToolsCarousel',
  mixins: [ inViewport ],

  data () {
    return {
      activeIndex: 0,
      paused: true,
      showNextTimer: null
    }
  },

  watch: {
    'inViewport.now' (isTrue) {
      if (isTrue) {
        this.paused = false
        this.resetTimer()
      } else {
        this.paused = true
        clearTimeout(this.showNextTimer)
      }
    }
  },

  methods: {
    setActive (index) {
      this.activeIndex = index || 0
      this.resetTimer()
    },

    isActive (index) {
      return this.activeIndex === index
    },

    toPrevious () {
      this.activeIndex = ((this.activeIndex - 1) + config.COUNT) % config.COUNT
      this.resetTimer()
    },

    toNext () {
      this.activeIndex = (this.activeIndex + 1) % config.COUNT
      this.resetTimer()
    },

    showNext () {
      if (this.paused) { return }
      this.toNext()
    },

    resetTimer () {
      clearTimeout(this.showNextTimer)
      this.showNextTimer = setTimeout(() => {
        clearTimeout(this.showNextTimer)
        this.showNext()
      }, config.INTERVAL)
    }
  },

  mounted () {
    this.resetTimer()
    if (this.inViewport.now) {
      this.paused = false
    }
  },

  beforeDestroy () {
    clearTimeout(this.showNextTimer)
  }
}
</script>

<template lang="pug">
section.edu-tools-carousel
  .tabs
    .tab-item(:class="{'active': isActive(0)}" @click="setActive(0)")
      h4.item-title 专业场景化评估
      p.item-text 格米专家团队针对学生入学状态、心理发展跟踪与建档、生涯规划、选科选课、填报志愿、危机预警与干预等不同场景，针对性建立模型和开发评估工具，不当量表搬运工。
    .tab-item(:class="{'active': isActive(1)}" @click="setActive(1)")
      h4.item-title 智能评估报告
      p.item-text 借助先进的云计算、大数据等技术，评估完成后实时计算分数、自动生成个体报告，为学生提供科学全面和个性化的发展指导建议。
    .tab-item(:class="{'active': isActive(2)}" @click="setActive(2)")
      h4.item-title 发展指导建议
      p.item-text 根据评估结果为学生提供发展指导建议，并推荐相应的在线课程、书籍，发挥学生的自主自助和自我教育能力。
    .tab-item(:class="{'active': isActive(3)}" @click="setActive(3)")
      h4.item-title 个别化辅导与干预
      p.item-text 自动识别有心理困扰或潜在问题的学生，推荐接受相应的辅导和干预（心理/学业/生活/家庭/生涯……），提高其心理健康水平和综合发展质量。
  .body
    template(v-for="n in 4")
      transition(name="fade" appear)
        .body-item(v-if="isActive(n - 1)" :key="n")
          .preview-img(:class="`tools-preview-img-${n}`")
</template>

<style lang="scss">
@import "../../styles/variables";

section.edu-tools-carousel {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  .body {
    flex: 1 1 0.000001px;
    position: relative;
    height: 680px;

    .body-item {
      @include absFullSpread;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-end;
      align-items: center;

      .preview-img {
        @include bgImage;
        height: 679px;
        width: 456px;
        background-position: bottom center;
        &.tools-preview-img-1 {
          background-image: url(../../assets/images/edu-tools-1.png);
        }
        &.tools-preview-img-2 {
          background-image: url(../../assets/images/edu-tools-2.png);
        }
        &.tools-preview-img-3 {
          background-image: url(../../assets/images/edu-tools-3.png);
        }
        &.tools-preview-img-4 {
          background-image: url(../../assets/images/edu-tools-4.png);
        }
      }
    }
  }

  .tabs {
    width: 500px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: stretch;

    .tab-item {
      flex: 1 1 0.000001px;
      padding: 20px 30px;
      cursor: pointer;
      transition: background .3s, border-color .3s;
      border-right: 8px solid transparentize($primary-color, 1);

      &:hover {
        background: transparentize($bg-lighter-gray, 0.5);
        border-right-color: transparentize($primary-color, 0.6);
      }

      &.active {
        background: $bg-lighter-gray;
        border-right-color: $primary-color;

        .item-title {
          color: $primary-color;
        }
      }
    }

    .item-title {
      color: $text-dark;
      font-weight: 600;
      margin-bottom: 0.5em;

      transition: color .3s;
    }

    .item-text {
      font-size: 14px;
    }
  }
}
</style>
